import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TitledPanel from '../core/TitledPanel';
import GS from '../grafsync/grafsync';
import ActionText from './ActionText';
import BasicChip from './BasicChip';
import Errored from './Errored';
import Loading from './Loading';
import { globalStyles as styles } from './style/gstheme';
import { makeCancelable, sortObjects } from './utils/utils';

class GroupSelector extends Component {

  constructor(props) {
    super(props);
    this.state = {
      groups: [],
      isLoadingGroups: true,
      isErrored: null
    };
    this.cancellable = null;
  }

  componentDidMount() {
    this.doSearch({
      search: [{
        predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
        value: "https://graphifi.com/schema/accesscontrol/UserGroup"
      }],
      sort: ["http://www.w3.org/2000/01/rdf-schema#label"],
      page: 1,
      graph: [GS.getActiveSubscription()],
      noCount: true,
      pageSize: 200
    })
      .promise
      .then(data => {
        const sortedGroups = data.results ? sortObjects([...data.results], 'label') : null;
        this.setState({ groups: sortedGroups, isLoadingGroups: false });
      })
      .catch((e) => {
        if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
      });
  }

  doSearch(payload) {
    this.cancellable = makeCancelable(GS.search(payload));
    return this.cancellable;
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  render() {

    const { groupList, handleToggle, adminIsEditable, isReadOnly } = this.props;
    const { isLoadingGroups, groups, isErrored } = this.state;

    if (isErrored) return <Errored data={isErrored} />;
    if (isLoadingGroups) return <Loading />;
    if (!groups || groups.length === 0) return <ActionText offset="130px">You do not have permission to alter groups.</ActionText>;

    return (
      <React.Fragment>
        {!adminIsEditable &&
          <Typography paragraph={true} variant="body2" style={{ paddingRight: '16px' }}>The administrator group is always available for every project and cannot be edited.</Typography>
        }
        <Grid container spacing={2} style={!adminIsEditable ? { height: 'calc(100% - 30px)' } : { height: '100%' }}>
          <Grid item xs={12} md={6}>
            <TitledPanel dataTest="available-groups" title="Available Groups" height="full">
              {groups
                .filter(group => !groupList.includes(group.id))
                .filter(group => !adminIsEditable && group.id === "https://graphifi.com/data/usergroup/admins" ? false : true)
                .map((group, index) =>
                  <BasicChip
                    key={"available-chip-" + index}
                    dataTest={"group-" + group.label["en"]}
                    onClick={!isReadOnly ? (() => handleToggle(group.id)) : null}
                    label={group.label["en"]}
                  />
                )}
            </TitledPanel>
          </Grid>
          <Grid item xs={12} md={6}>
            <TitledPanel dataTest="assigned-groups" title="Assigned Groups" height="full">
              {groupList && groups
                .filter(group => groupList && groupList.includes(group.id))
                .filter(group => !adminIsEditable && group.id === "https://graphifi.com/data/usergroup/admins" ? false : true)
                .map((group, index) =>
                  <BasicChip
                    key={"assigned-chip-" + index}
                    dataTest={"group-" + group.label["en"]}
                    onDelete={!isReadOnly ? (() => handleToggle(group.id)) : null}
                    label={group.label["en"]}
                  />
                )}

            </TitledPanel>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

GroupSelector.defaultProps = {
  adminIsEditable: true,
  isReadOnly: false
};

GroupSelector.propTypes = {
  classes: PropTypes.object.isRequired,
  handleToggle: PropTypes.func.isRequired,
  groupList: PropTypes.array.isRequired,
  isReadOnly: PropTypes.bool,
  adminIsEditable: PropTypes.bool
};

export default withStyles(styles)(GroupSelector);